import { render, staticRenderFns } from "./ClientDatabaseTableModal.vue?vue&type=template&id=8131ba70&scoped=true&"
import script from "./ClientDatabaseTableModal.vue?vue&type=script&lang=js&"
export * from "./ClientDatabaseTableModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientDatabaseTableModal.vue?vue&type=style&index=0&id=8131ba70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8131ba70",
  null
  
)

export default component.exports